import React, { useState } from 'react'
import styled from 'styled-components'
import cookie from 'react-cookies'
import { isMobile } from 'react-device-detect'
import { useHistory } from 'react-router-dom'

import closeIcon from '../../assets/mainScreen/closeIcon.png'
import { fontSizeResponsive, mediaQ } from '../theme/mixins'

const DemoModeAnnouncementContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  width: calc(100% - 40px);
  padding: 10px 30px;
  background: linear-gradient(
    90deg,
    rgba(254, 13, 160, 0.5) 0%,
    rgba(250, 174, 1, 0.5) 100%
  );
  margin: 10px 20px;
  box-sizing: border-box;
  /* opacity: 0.6; */
  border-radius: 6px;
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  backdrop-filter: blur(10px);
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);

  ${fontSizeResponsive(28)};

  ${mediaQ(
    'mobileAll',
    'bottom: 10vh; width: calc(100% - 10px);margin: 10px 5px;'
  )}
`

const DemoModeAnnouncementText = styled.div`
  align-self: center;
  color: #f8f8f8;
`

const DemoModeAnnouncementButton = styled.button`
  align-self: center;
  padding: 10px 30px;

  border: none;
  outline: none;
  background-color: rgba(158, 13, 254, 1);
  border-radius: 4px;

  font-family: 'Asap Condensed';
  text-align: center;
  font-weight: 600;
  color: white;
  -webkit-transition: ease-in-out 0.35s all;
  transition: ease-in-out 0.35s all;
  ${fontSizeResponsive(32)};
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);

  &:hover {
    transform: scale(1.05);
    cursor: pointer;
  }
`

const CloseDemoModeAnnouncement = styled.button`
  position: absolute;
  z-index: 2;
  right: 2px;
  top: 2px;
  width: 20px;
  height: 20px;
  background: url(${closeIcon});
  background-size: contain;
  background-repeat: no-repeat;
  border: none;
`

const DemoModeAnnouncement = () => {
  const [isAnnouncementVisible, setAnnouncementVisible] = useState(true)
  let history = useHistory()

  const redirectToBuy = () => {
    // cookie.remove('userDemoMode')
    history.push('/wybierz-plan/sub')
  }

  return (
    <>
      {isAnnouncementVisible && (
        <DemoModeAnnouncementContainer>
          <DemoModeAnnouncementText>
            {isMobile
              ? 'By odblokować wszystkie usługi wykup subskrypcje.'
              : 'Korzystasz z aplikacji z ograniczonymi możliwościami. By odblokować wszystkie usługi wykup subskrypcje.'}
          </DemoModeAnnouncementText>
          <DemoModeAnnouncementButton onClick={redirectToBuy}>
            {isMobile ? 'Kup' : 'Wykup subskrypcję'}
          </DemoModeAnnouncementButton>
          <CloseDemoModeAnnouncement
            onClick={() => setAnnouncementVisible(false)}
          />
        </DemoModeAnnouncementContainer>
      )}
    </>
  )
}

export default DemoModeAnnouncement
